// @flow
import * as React from 'react'
import PRTitle from '../../../components/pull_request/PRTitle'

type Props = {
  model: Object,
  header?: boolean
}

export default class PRTitleContainer extends React.Component<Props> {
  render () {
    const model = this.props.model

    const prUrl = model.get('pr_html_url')
    const prNumber = prUrl.substr(prUrl.lastIndexOf('/') + 1)
    const prTitle = model.get('pr_title')
    const prStatus = model.get('pr_status')
    const href = this.props.header ? prUrl : model.pullRequestPagePath()

    return (
      <PRTitle
        href={href}
        prNumber={prNumber}
        prTitle={prTitle}
        prStatus={prStatus}
        header={this.props.header}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/pull_request/Header/PRTitleContainer.js